/**
 * Возвращает строку для текущего языка из локализуемого поля newsData.
 *
 * Локализуемые поля в newsData могут быть либо обычной строкой (нелокализованной),
 * либо объектом вида { ru: "...", kk: "...", en: "..." }.
 *
 * @param {string|{ru?: string, kk?: string, en?: string}|null|undefined} field
 * @param {string} lang - текущий язык i18n (i18n.language), напр. "ru" | "kk" | "en"
 * @returns {string} строка на нужном языке (с фолбэком на ru), либо исходное значение
 */
export const pickLang = (field, lang) => {
  if (field && typeof field === 'object') {
    return field[lang] || field.ru || '';
  }
  return field;
};

export default pickLang;
